import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  UncontrolledTooltip,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import Select from 'react-select';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Loader from '../../../commons/loader';
import Services from './services';
import { PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import moment from 'moment';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import Lib from '../../../commons/lib';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import NumberFormatter from '../../../commons/NumberFormatter';

class KenyelmiDijContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      angolNyelv: false,

      // ['LOAD', 'DATA', 'NETW', 'TABL']
      tableStatus: 'TABL',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'LOAD',
      // ['FEL', 'MOD']
      formType: 'FEL',
      
      // FORM VALUES
      formPenznem: '',
      formSzazalek: '',
      formOsszeg: '',
      formHelyszin: [],
      penznemOptions: [],
      penznemek: [],
      helyszinOptions: [],


      // TABLE VALUES 
      baseJson: [],
      currentId: undefined,
      torlesId: undefined,

      // MODAL UTILS
      modalForm: false,
      modalDelete: false,
      formButtonLoading: false,
      deleteButtonLoading: false,
      isTable: true,
    };
  }

  componentDidMount() {
    this.listKenyelmiDij();
  }

  hasRole = (roles, checkKarb) => {
    return this.props.globals.hasRole(roles, checkKarb);
  }

  toggleFormModal = () => {
    this.setState(prevState => ({ modalForm: !prevState.modalForm }));
  }

  toggleDeleteModal = () => {
    this.setState(prevState => ({ modalDelete: !prevState.modalDelete }));
  }

  handleTableLayoutChange = () => {
    this.setState(prevState => ({ isTable: !prevState.isTable }));
  }

  listKenyelmiDij = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Services.listKenyelmiDij((err, res) => {
        if (!err) {
          this.setState({
            tableStatus: res[0].length > 0 ? 'TABL' : 'DATA',
            baseJson: res[0],
          });
        } else {
          this.setState({
            tableStatus: 'NETW'
          });
        }
      });
    });
  }

  handleNewClick = () => {
    this.setState({
      formType: 'FEL',
      formStatus: 'DATA',
      formPenznem: '',
      formSzazalek: '',
      formOsszeg: '',
      formHelyszin: [],
      currentId: null
    }, () => {
      this.initKenyelmiDijForm(null);
      this.toggleFormModal();
  });
  }

  handleEditClick = (id) => {
    this.setState({
      formType: 'MOD',
      formStatus: 'LOAD',
      currentId: id,
      formPenznem: '',
      formSzazalek: '',
      formOsszeg: '',
      formHelyszin: [],
    }, () => {
      this.initKenyelmiDijForm(id);
      this.toggleFormModal();
    });
  }

  handleDeleteClick = (id) => {
    this.setState({
      torlesId: id
    }, () => {
      this.toggleDeleteModal();
    });
  }

  handleInputChange = (e) => {
    console.log("input");
    let x = this.state.penznemek.filter(x => parseInt(this.state.formPenznem, 10) === x.id);
    console.log(x);
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  handleHelyszinChange = (newValue) => {
    console.log(newValue);
    let helyszinIds = [];

    newValue.forEach((item) => {
      helyszinIds.push(
        item.helyszinid
      );
    });

    this.setState({ formHelyszin: newValue });
  };

  saveKenyelmiDij = (e) => {
    const {
      formType,
      currentId,
      formPenznem,
      formOsszeg,
      formSzazalek,
      formHelyszin,
    } = this.state;

    this.setState({
      saveButtonLoading: true
    }, () => {
      if (formType === 'FEL') {
        let submitObj = {
          penznemid: formPenznem,
          osszeg: formOsszeg,
          szazalek: formSzazalek,
          helyszinids: formHelyszin && formHelyszin.map(x => x.helyszinid),
        };

        Services.insertKenyelmiDij(submitObj, (err) => {
          if (!err) {
            this.toggleFormModal();
            this.listKenyelmiDij();
            this.props.globals.addSuccess('Kényelmi díj felvéve!');
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
  
      if (formType === 'MOD') {
        let submitObj = {
          id: currentId,
          penznemid: formPenznem,
          osszeg: formOsszeg,
          szazalek: formSzazalek,
          helyszinids: formHelyszin.map(x => x.helyszinid),
        };


        Services.modifyKenyelmiDij(submitObj, (err) => {
          if (!err) {
            this.toggleFormModal();
            this.listKenyelmiDij();
            this.props.globals.addSuccess('Kényelmi díj módosítva!');
            this.setState({
              saveButtonLoading: false
            });
          } else {
            this.setState({
              saveButtonLoading: false
            });
          }
        });
      }
    });
  }

  initKenyelmiDijForm = (id) => {
    this.setState({
      formStatus: 'LOAD', 
    }, () => {
      Services.initKenyelmiDijForm(id, (err, res) => {
        if (!err) {
          this.setState({
            formPenznem: id ? res[0].kenyelmidij && res[0].kenyelmidij.penznemid : res[0].defaultpenznemid,
            formSzazalek: res[0].kenyelmidij && res[0].kenyelmidij.szazalek,
            formOsszeg: res[0].kenyelmidij && res[0].kenyelmidij.osszeg,
            formHelyszin: res[0].kenyelmidij && res[0].kenyelmidij.helyszinids && res[0].helyszin && res[0].helyszin.filter(x => res[0].kenyelmidij.helyszinids.includes(x.helyszinid)),
            formStatus: 'DATA', 

            penznemOptions: res[0].penznem.map(e => <option key={e.id} value={e.id}>{e.azonosito}</option>),
            penznemek: res[0].penznem,
            helyszinOptions: res[0].helyszin,
          });
        } else {
          this.setState({
            formStatus: 'NETW',
          });
        }
      });
    });
  }

  deleteKenyelmiDij = () => {
    this.setState({
      deleteButtonLoading: true
    });
    Services.deleteKenyelmiDij(this.state.torlesId, (err) => {
      if (!err) {
        this.toggleDeleteModal();
        this.listKenyelmiDij();
        this.props.globals.addSuccess('Kényelmi díj törölve!');
        this.setState({
          deleteButtonLoading: false
        });
      } else {
        this.setState({
          deleteButtonLoading: false
        });
      }
    });
  }
  
  dijFormatter = (cell, row) => {
    let dij = row.szazalek ? (NumberFormatter.addSpacesToString(row.szazalek, NumberFormatter.OSSZEG) + '%') : '';
    dij += row.szazalek && !row.osszeg ? ' (' + row.penznem + ')' : '';
    dij += row.szazalek && row.osszeg ? ' + ' : '';
    dij += row.osszeg ? NumberFormatter.addSpacesToString(row.osszeg, NumberFormatter.OSSZEG) + ' ' + row.penznem : '';

    return dij.trim();
  }

  tableIconFormatter = (cell) => {
    return (
      <div>
        {this.hasRole(['MUSOR_MUSOR'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell + 'edit'} onClick={() => this.handleEditClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-edit-' + cell + 'edit'} delay={50}>
              {'Módosítás'}
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-delete-' + cell + 'delete'} onClick={() => this.handleDeleteClick(cell)} onMouseDown={(e) => { if (e) e.preventDefault(); }} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-delete-' + cell + 'delete'} delay={50}>
              {'Törlés'}
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderTable = () => {
    const columns = [
      {
        dataField: 'helyszinek',
        text: 'Helyszín(ek)',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        text: 'Kényelmi díj mértéke',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        sortValue: this.dijFormatter,
        formatter: this.dijFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.tableIconFormatter
      }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderTableView = () => {
    return (
      <div className="col-md-12">
        {{
          LOAD: (<Loader />),
          DATA: (<DataEmptyState
            hasImage
            subtitle="Vigyél fel új tételt!"
          />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => { this.listKenyelmiDij(); }}
          />),
          TABL: (this.renderTable())
        }[this.state.tableStatus]}
      </div>
    );
  }

  renderForm = () => {
    return (
      <React.Fragment>
        <div className="row">
            <div className="col-md-12">
              <RFField
                type="select"
                name="formPenznem"
                label="Pénznem: *"
                errorMessage="Kötelező mező!"
                onChange={this.handleInputChange}
                required
                defaultSelect={<option value="" disabled>Válassz pénznemet...</option>}
                selectOptions={this.state.penznemOptions}
                value={this.state.formPenznem}
                />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <SlaveAvInput
                key="formSzazalek"
                id="formSzazalek"
                label={'Kényelmi díj százalék:'}
                value={this.state.formSzazalek}
                autoComplete="off"
                onChange={this.handleInputChange}
                szuroTipus={NumberFormatter.EGYSEGAR}
                emptyStringOnZero
                append={'%'}
              />
            </div>
            <div className="col-md-6">
              <SlaveAvInput
                key="formOsszeg"
                id="formOsszeg"
                label={'Kényelmi díj összeg:'}
                value={this.state.formOsszeg}
                autoComplete="off"
                onChange={this.handleInputChange}
                szuroTipus={NumberFormatter.EGYSEGAR}
                emptyStringOnZero
                append={this.state.formPenznem && this.state.penznemek.find(x => this.state.formPenznem == x.id).azonosito}
                />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
            <Label>Helyszín(ek): * </Label>
            <Select
              styles={{
                control: base => ({
                  ...base,
                  '&:focus': { borderColor: 'red' }, // border style on hover
                  border: '1px solid lightgray', // default border color
                  boxShadow: 'none', // no box-shadow
                  borderRadius: '0'
                }),
              }}
              name="formHelyszin"
              id="formHelyszin"
              isClearable
              placeholder="Kezdj el gépelni..."
              onChange={this.handleHelyszinChange}
              isMulti
              options={this.state.helyszinOptions}
              getOptionLabel={option => option.helyszinnev}
              getOptionValue={option => option.helyszinid}
              value={this.state.formHelyszin}
              cache={false}
              autoload={false}
              required
            />
            </div>
          </div>
      </React.Fragment>
    );
  }

  renderModals = () => {
    return (
      <React.Fragment>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleFormModal} backdrop="static">
          <RFForm
            modal
            onSubmit={this.saveKenyelmiDij}
            title={this.state.currentId ? 'Kényelmi díj módosítása': 'Kényelmi díj rögzítése'}
            footer={
              <React.Fragment>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.formButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" onClick={this.toggleFormModal}>Mégsem</Button>
              </React.Fragment>
            }
          >
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.initKenyelmiDijForm(this.state.currentId)}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          </RFForm>
        </Modal>
        
        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDeleteModal} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              type="button"
              onClick={() => this.deleteKenyelmiDij()}
              loading={this.state.deleteButtonLoading}
            >
              {'Igen'}
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleDeleteModal}>Mégsem</Button>
          </ModalFooter>
        </Modal>
    </React.Fragment>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-12">
            {this.hasRole(['MUSOR_MUSOR'], true) && (
              <Button className="pull-left table-new-button" color="primary" onClick={this.handleNewClick}>
                {'Új kényelmi díj'}
              </Button>
            )}
          </div>
          {this.renderTableView()}
        </div>
        {this.renderModals()}
      </React.Fragment>
    );
  }
}

KenyelmiDijContent.propTypes = {
  globals: PropTypes.object
};

export default KenyelmiDijContent;